import Carousel from 'react-grid-carousel'
import './styles/testimonials.scss'
import test1 from './images/caroline_pattullo.webp'
import test2 from './images/chethan_babu.webp';
import test3 from './images/david_nichol.webp';
import test4 from './images/graeme_reid.webp';
import test5 from './images/hayley_mctaggart.webp';
import test6 from './images/jay_bloomfield.webp';
import test7 from './images/jenna_playfair.webp';
import test8 from './images/maria_carenduff.webp';
import test9 from './images/martin_moore.webp';
import test10 from './images/natalie_mcginlay.webp';
import test11 from './images/nicola_reid.webp';
import test12 from './images/rodger_boyd.webp';

export default function Testimonials(){
  return(
    <main className="testimonials">
      <Carousel cols={3} rows={1} gap={8} loop hideArrow={false} showDots={true}>
        <Carousel.Item >
          <img src={test1} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test2} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test3} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test4} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test5} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test6} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test7} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test8} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test9} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test10} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test11} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>
        <Carousel.Item >
          <img src={test12} alt="testimonial screenshot" className='carousel--image'/>
        </Carousel.Item>

        {/* ... */}
      </Carousel>

    </main>
  )
}